import React from "react";
import { useTranslation } from "react-i18next";

export const RequiredFieldsInformation = (): JSX.Element => {
	const { t } = useTranslation();
	return <small>{t("lib:go_security.register.header.information.required")}</small>;
};
